// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {getDatabase} from "firebase/database";
import {
  collection,
  connectFirestoreEmulator,
  doc,
  getFirestore,
} from "firebase/firestore";
import {connectFunctionsEmulator, getFunctions} from "firebase/functions";

import {CONFIG} from "~/config";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBwf3P2ID5cgSA-6qaCq08UX7qGuLyl-DU",
  authDomain: "orbitdash-58971.firebaseapp.com",
  projectId: "orbitdash-58971",
  storageBucket: "orbitdash-58971.appspot.com",
  messagingSenderId: "465649615684",
  appId: "1:465649615684:web:692e85b38302a3fa36cd11",
  measurementId: "G-KVHKETYGWQ",
  databaseURL:
    "https://orbitdash-58971-default-rtdb.europe-west1.firebasedatabase.app",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Initialize Functions
export const functions = getFunctions(app, CONFIG.FIREBASE_REGION);

// Initialize Firestore
export const firestore = getFirestore(app);
export const realtimeDB = getDatabase(app);
export const createRandomDocId = () => doc(collection(firestore, "any")).id;

if (false && window.location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectFirestoreEmulator(firestore, "localhost", 8080);
}
